module.exports = __webpack_public_path__ + "5aa20a966b4c9fd362065b34bc90858f.png";